import { useAppDispatch } from "app.hook";
import { FormikErrors, FormikProps, useFormik } from "formik";
import React, { FC, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ACCOUNT_LOGIN_ROUTE } from "shared/constants/routes";
import useCallback from "shared/hooks/use-callback";
import { resetPasswordAPI } from "states/account/account.api";
import { IResetPasswordModel } from "states/account/account.models";
import { setLoading, showError } from "states/global-value/global-value.slice";
import { IconArrowLeft, IconSuccess } from "themes/icons";
import { PrimaryButton } from "themes/style-components/button";
import { FlexAuto, FlexContainer, FlexLeft, FlexLeftContainer } from "themes/style-components/flex";
import { FormControl, FormError, FormGroup, FormGroupNotFlex } from "themes/style-components/form-group";
import { H1, H2, H3, } from "themes/style-components/typography";
const ResetPasswordPage: FC = (props) => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const [callbackQuery, callbackUrl] = useCallback("callback");
  const [isSuccess, setSuccess] = useState<boolean>(false);
  const dispatch = useAppDispatch();
  const formik: FormikProps<IResetPasswordModel> = useFormik<IResetPasswordModel>({
    initialValues: {
      userId: queryParams.get("userId")?.toString() ?? "",
      newPassword: "",
      confirmPassword: "",
      email: queryParams.get("email")?.toString() ?? "",
      token: queryParams.get("code")?.toString() ?? "",
    },
    validateOnChange: true,
    validate: (values) => {
      let errors: FormikErrors<IResetPasswordModel> = {};
      if (values.newPassword === "") {
        errors.newPassword = "Please enter password";
      }
      else if (values.newPassword.length < 6) {
        errors.newPassword = "At least 6 characters";
      }
      if (values.confirmPassword === "") {
        errors.confirmPassword = "Please enter confirm password";
      } else if (values.newPassword !== values.confirmPassword) {
        errors.confirmPassword = "Password must match";
      }

      return errors;
    },

    onSubmit: async (values) => {
      dispatch(setLoading(true));
      try {
        values.token = values.token.replaceAll(" ","+");
        await resetPasswordAPI(values);
        dispatch(setLoading(false));
        setSuccess(true);
      } catch (err  : any) {
        dispatch(setLoading(false));
        dispatch(showError(err?.response?.data?.error?.message));
      }
    },
  });
  useEffect(() => {
    document.title = "Reset Password";
  }, [])
  return (
    <div>
      <FlexContainer>
        <FlexLeftContainer>
          <Link to={`${ACCOUNT_LOGIN_ROUTE}${callbackQuery}`}>
            <IconArrowLeft width={15} />
          </Link>
        </FlexLeftContainer>
        <FlexAuto className="text-center">
          <H3 className="mb-8">Reset Password</H3></FlexAuto>
      </FlexContainer>
      {isSuccess ? (
        <div className="text-center mx-auto">
          <IconSuccess width={50} className="mb-3 text-center mx-auto" />
          <p>Reset password successfully</p>
          <Link to={`${ACCOUNT_LOGIN_ROUTE}${callbackQuery}`}>
            <PrimaryButton className="block w-full mt-4" type="button">Login</PrimaryButton>
          </Link>
        </div>
      ) : (
        <>
          <div className="text-center mb-8">
            <p>Create a new password for</p>
            <p>{formik.values.email}</p>
          </div>
          <form onSubmit={formik.handleSubmit}>
            <FormGroupNotFlex>
              <FormControl>
                <input id="password"
                  name="newPassword"
                  type="password"
                  placeholder="Password"
                  onChange={formik.handleChange}
                  value={formik.values.newPassword} />
              </FormControl>
              {formik.errors.newPassword && (
                <FormError>
                  {formik.errors.newPassword}
                </FormError>
              )}
            </FormGroupNotFlex>
            <FormGroupNotFlex className="mt-4">
              <FormControl>
                <input
                  id="confirm__password"
                  name="confirmPassword"
                  type="password"
                  placeholder="Confirm Password"
                  onChange={formik.handleChange}
                  value={formik.values.confirmPassword} />
              </FormControl>
              {formik.errors.confirmPassword && (
                <FormError>
                  {formik.errors.confirmPassword}
                </FormError>
              )}
            </FormGroupNotFlex>
            <PrimaryButton className="block w-full mt-4" type="submit">Submit</PrimaryButton>
          </form>
        </>
      )}
    </div>
  );
};

export default ResetPasswordPage;
